export default "__VITE_ASSET__DdHn3K_o__"